import { profileHash } from "PFCore/helpers/profile_hash";
import { prune } from "underscore.string";

const CustomField = (data, customTypes, typeName, styleConfig, bullet) => {
  const { titleColor, titleFontSizeSidebar, textFontSizeSidebar, textColor } = styleConfig;
  const customField = customTypes.find(({ type }) => type.name === typeName);

  if (!customField || !customField.text) {
    return false;
  }

  data.push({
    text: customField.displayAs,
    options: {
      lineSpacing: 15,
      fontSize: titleFontSizeSidebar,
      color: titleColor,
      bold: true,
      breakLine: true
    }
  });
  if (bullet) {
    customField.text
      .split(", ")
      .slice(0, 3)
      .map((item) =>
        data.push({
          text: item,
          options: {
            fontSize: textFontSizeSidebar,
            color: textColor,
            breakLine: true,
            bullet: { indent: 10, code: "2013" }
          }
        })
      );
  } else {
    data.push({
      text: prune(customField.text, 300),
      options: { fontSize: textFontSizeSidebar, color: textColor, breakLine: true }
    });
  }
};

const Positions = (data, positions, styleConfig) => {
  const { titleColor, titleFontSize, textFontSize, textColor } = styleConfig;
  if (!positions?.items || positions.items.length === 0) {
    return false;
  }

  data.push({
    text: positions.header,
    options: { lineSpacing: 25, fontSize: titleFontSize, color: titleColor, bold: true, breakLine: true }
  });
  positions.items.slice(0, 3).map(({ jobTitle, companyName, summary }) => {
    data.push({
      text: companyName ? `${jobTitle} in ${companyName}` : jobTitle,
      options: {
        bold: true,
        fontSize: textFontSize,
        color: textColor,
        bullet: { indent: 10, code: "2013" }
      }
    });
    summary &&
      data.push({
        text: prune(summary?.replace(/\r?\n|\r/g, " "), 300),
        options: {
          softBreakBefore: true,
          fontSize: textFontSize,
          color: textColor
        }
      });
  });
};

const Summary = (data, summary, styleConfig) => {
  const { titleColor, titleFontSize, textFontSize, textColor } = styleConfig;
  if (!summary) {
    return false;
  }

  data.push({
    text: "Summary",
    options: { lineSpacing: 25, fontSize: titleFontSize, color: titleColor, bold: true, breakLine: true }
  });
  data.push({
    text: prune(summary, 500),
    options: { fontSize: textFontSize, color: textColor, breakLine: true }
  });
};

const Contacts = (data, contactInformationItems, email, styleConfig) => {
  const { textFontSizeSidebar, textColor } = styleConfig;

  [{ type: "Email", text: email }, ...contactInformationItems].slice(0, 3).map(({ type, text }) => {
    data.push({
      text: `${type}: `,
      options: { bold: true, fontSize: textFontSizeSidebar, color: textColor }
    });
    data.push({
      text,
      options: { breakLine: true, fontSize: textFontSizeSidebar, color: textColor, shrinkText: true }
    });
  });
};

const localExportBuildPptx = (data, config, order, pptxgen) => {
  const pptx = new pptxgen();
  const slide = pptx.addSlide();

  const styleConfig = {
    titleColor: config.color,
    subtitleColor: config.color2,
    textColor: "111111",
    textFontSize: 11,
    titleFontSize: 14,
    textFontSizeSidebar: 10,
    titleFontSizeSidebar: 13
  };

  const leftPanelXOffset = 0.3;
  let leftPanelYOffset = 0.3;

  // left column (sidebar)
  if (data.avatar && !config.isBlindModeOn) {
    slide.addImage({ x: leftPanelXOffset, y: leftPanelYOffset, w: 1.7, h: 1.7, data: data.avatar });
    leftPanelYOffset = 2.1;
  }

  const leftPanelTextArray = [];

  if (!config.isBlindModeOn) {
    Contacts(leftPanelTextArray, data.contactInformationItems, data.email, styleConfig);
  }

  order
    .filter((itemName) => !config.hidden[itemName] && ["certificates", "qualifications"].includes(itemName))
    .map((itemName) => CustomField(leftPanelTextArray, data.customTypes, itemName, styleConfig, true));

  slide.addText(leftPanelTextArray, {
    x: leftPanelXOffset - 0.1,
    y: leftPanelYOffset,
    w: 2,
    h: 5,
    valign: "top",
    maring: 0
  });

  // logo
  if (data.logo.custom) {
    slide.addImage({ x: leftPanelXOffset, y: 5.2, w: 0.3, h: 0.3, data: data.logo.url });
  } else {
    slide.addImage({ x: leftPanelXOffset, y: 5.2, w: 1, h: 0.3, path: data.logo.url });
  }

  // separator
  slide.addShape(pptx.shapes.LINE, {
    x: 2.2,
    y: 0.3,
    w: 0.0,
    h: 5.0,
    line: { color: styleConfig.subtitleColor, width: 2 }
  });

  // right panel

  const rightPanelXOffset = 2.4;
  const rightPanelYOffset = 0.3;
  const rightPanelTextArray = [
    {
      text: config.isBlindModeOn ? `Candidate ${profileHash(data.id)}` : data.name,
      options: { fontSize: 20, color: styleConfig.titleColor, breakLine: true }
    },
    { text: data.jobTitle, options: { fontSize: 15, color: styleConfig.subtitleColor, breakLine: true } }
  ];

  order
    .filter((itemName) => !config.hidden[itemName])
    .map((itemName) => {
      if (itemName === "summary" && data.summary) {
        Summary(rightPanelTextArray, data.summary, styleConfig);
      }

      if (itemName === "experience") {
        Positions(rightPanelTextArray, data.positions, styleConfig);
      }
    });

  slide.addText(rightPanelTextArray, {
    x: rightPanelXOffset,
    y: rightPanelYOffset,
    w: 7.5,
    h: 5,
    valign: "top",
    margin: 0
  });

  return pptx;
};

export default localExportBuildPptx;
